module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/53feb95d87a0cabdba0602df4b2c7abd.png";